/** The build version marker (`v:DD.MM.HH.MM`), injected at build time by Vite so it
 *  changes on every deploy. Rendered under the Logout buttons in both the admin
 *  sidebar and the customer settings screen. */
export function AppVersion({ className }: { className?: string }) {
  return (
    <span className={className ?? 'block text-center text-[11px] text-muted-foreground'}>
      {__APP_VERSION__}
    </span>
  );
}
